module.exports = __webpack_public_path__ + "img/br.ce463b88.svg";